module.exports = __webpack_public_path__ + "img/icon-admin.58561b0e.svg";